import { DestroyRef, Inject, inject, Injector } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WidgetSettingsToken } from '@common-modules/dynamic-layout/dynamic-layout.tokens';
import { DynamicLayoutConfigurableItemSettings } from '@common-modules/dynamic-layout/models/dynamic-layout-configurable-item-settings';
import { BaseDynamicWidgetComponent } from '@common-modules/redux/components/base-dynamic-widget.component';
import { StateWidgetSettings } from '@common-modules/redux/models/state-widget-settings';
import { DashboardManagerService } from '@common-modules/right-panel/dashboards/dashboard-manager.service';
import { DashboardChildWidgetParams } from '@common-modules/right-panel/dashboards/dashboard-widget-params';
import { globalUtilsHelper } from '@common-modules/shared/helpers/global-utils-helper';

export abstract class BaseDashboardWidgetComponent extends BaseDynamicWidgetComponent {
  protected readonly _dashboardManagerService = inject(DashboardManagerService);
  protected readonly _destroyRef = inject(DestroyRef);

  protected params: DashboardChildWidgetParams;

  constructor(
    injector: Injector,
    @Inject(WidgetSettingsToken) protected _widgetSettings: StateWidgetSettings
  ) {
    super(injector, _widgetSettings);
    this.params = _widgetSettings.itemSettings?.params;
  }

  protected listenSettingsChange(): void {
    this._dashboardManagerService.updateDashboardChild$
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((updatedParams: DashboardChildWidgetParams) => {
        if (this.params.dashboardChildId === updatedParams.dashboardChildId) {
          const updatedItemSettings = this.buildUpdatedItemSettings(updatedParams);
          this.updateItemSettings(updatedItemSettings);
          this.reload(updatedParams);
        }
      });
  }

  abstract reload(updatedParams: DashboardChildWidgetParams);

  private buildUpdatedItemSettings(updatedParams): DynamicLayoutConfigurableItemSettings {
    const updatedItemSettings: DynamicLayoutConfigurableItemSettings = {
      ...this._widgetSettings.itemSettings,
      params: globalUtilsHelper.clone(updatedParams, true),
    };

    return updatedItemSettings;
  }
}
